var map = {
	"./biomass.svg": 58,
	"./cogo-icon-green.svg": 59,
	"./cogoMore.svg": 60,
	"./doMore.svg": 61,
	"./eco-agriculture.svg": 62,
	"./eco-beauty.svg": 63,
	"./eco-business.svg": 64,
	"./eco-business2.svg": 65,
	"./eco-coffee.svg": 66,
	"./eco-fashion.svg": 67,
	"./eco-growth.svg": 68,
	"./eco-retail.svg": 69,
	"./eco-tourism.svg": 70,
	"./electric-bus.svg": 71,
	"./electric-hybridVehicles.svg": 72,
	"./energyHomes.svg": 73,
	"./energyTech.svg": 74,
	"./factory.svg": 75,
	"./foodWaste.svg": 76,
	"./gym.svg": 77,
	"./natwest-gogreen.svg": 78,
	"./pet-clothing.svg": 79,
	"./port.svg": 80,
	"./science.svg": 81,
	"./solarTechnology.svg": 82,
	"./supportingZero.svg": 83,
	"./supportingZeroLarge.svg": 84,
	"./tech-ecoRecycling.svg": 85,
	"./tidal-wavePower.svg": 86,
	"./wind-power.svg": 87,
	"./windFarm.svg": 88,
	"./zoo.svg": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;